import { controls, currencyToNumber, grouped } from "../../controls";

const rpad2 = {
  label: "Inspecting Officer Status",
  starting: true,
  url: "rp101m",
  pageLabel: "Inspecting Officer Status",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.displayText({ tab: "general", label: "Bank", star: true }),
    ...controls.oc({ tab: "general", length: 4, c: "Client", placeHolder: "Bank Code", name: "client_code", isRequired: true, fastpath: "clients" }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "client_display" }),
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Inspecting Officer Status",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    textReportProps: {
      'Recon': {
        filename: `Auditor Status-$pageData.as_on_date$.txt`,
        format: {},
        separator: "|"
      },
    },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Inspecting Officer Name",
        accessor: "user_display",
        rwidth: "*"
      },
      {
        Header: "Count",
        accessor: "assigned"
      }
    ]
  }
};

export default rpad2;